import { Badge } from "../../ui/badge";
import { Button } from "../../ui/button";

export default function WhatsAppDisponibilitaBadge({ availability, onConfirm, onConversation }) {
  if (!availability) return null;
  const label = availability.esito === "posti_disponibili"
    ? `${availability.posti ?? "?"} posti${availability.da_quando ? ` · ${availability.da_quando}` : ""}`
    : availability.esito === "nessun_posto" ? "Nessun posto" : "Risposta da chiarire";
  const pending = availability.stato === "da_confermare";
  return (
    <div className="mt-1 space-y-1">
      <Badge variant={availability.esito === "da_chiarire" ? "secondary" : pending ? "outline" : "default"} className="whitespace-normal text-left">
        WA: {label}{pending ? " · da confermare" : ""}
      </Badge>
      {availability.testo_originale && <p className="max-w-48 text-[10px] text-slate-500 line-clamp-2" title={availability.testo_originale}>{availability.testo_originale}</p>}
      <div className="flex gap-1">
        {pending && <Button size="sm" variant="ghost" className="h-6 px-1 text-[10px]" onClick={() => onConfirm?.(availability)}>Conferma</Button>}
        {availability.conversation_key && <Button size="sm" variant="ghost" className="h-6 px-1 text-[10px]" onClick={() => onConversation?.(availability.conversation_key)}>Conversazione</Button>}
      </div>
    </div>
  );
}
